// Clearwater Spas catalog (source: clearwaterspas.com). Images and spec PDFs hosted locally.
export const CLEARWATER_SPAS = [
 {
  "id": "cw-orlando",
  "name": "Orlando",
  "brand": "Clearwater Spas",
  "series": "Resort Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Orlando is the ultimate luxury spa in our Resort Series. With the largest selection of hydromassage therapy jets and four jet pumps, the Orlando provides you with an unparalleled massage experience. The exclusive his-and-hers seating configuration provides personalized hydrotherapy tailored to your needs—making this the perfect retreat for rejuvenation and everyday indulgence.",
  "image": "/images/clearwater/Orlando-1-600-1.png",
  "images": [
   "/images/clearwater/Orlando-1-600-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "6"
   },
   {
    "label": "Jets",
    "value": "107"
   },
   {
    "label": "Lounger",
    "value": "2"
   },
   {
    "label": "Pumps",
    "value": "4"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Size",
    "value": "93″ x 93″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "8′ x 8′ x 3′ (236 x 236 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 60-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "4 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "107 hydrotherapy jets, 4 zone air controls, 3 auxiliary therapy controls, 4 convenience controls, 2 reflexology foot massage jets"
   },
   {
    "label": "Water Capacity",
    "value": "540 gallons (2044 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "1101 lbs. (499 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "5604 lbs. (2542 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Orlando_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Orlando_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Orlando_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/01-CWS_ORLANDO_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-monaco",
  "name": "Monaco",
  "brand": "Clearwater Spas",
  "series": "Resort Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Monaco is the ultimate lounger spa in our Resort Series. Set the multi-colored LED mood lighting to your favorite colors. More jets and more pumps provide more therapy than any other competitive spa. The lounger offers more hydrotherapy jets than any other spa on the market, giving you the ultimate full-body massage.",
  "image": "/images/clearwater/Monaco-600-1.png",
  "images": [
   "/images/clearwater/Monaco-600-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "5"
   },
   {
    "label": "Jets",
    "value": "98"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "4"
   },
   {
    "label": "Capacity",
    "value": "5"
   },
   {
    "label": "Size",
    "value": "93″ x 93″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "8′ x 8′ x 3′ (236 x 236 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 60-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "4 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "98 hydrotherapy jets, 4 air controls, 4 convenience controls, 2 reflexology foot massage jets"
   },
   {
    "label": "Water Capacity",
    "value": "540 gallons (2044 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "1101 lbs. (499 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "5604 lbs. (2542 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "Lighted footwell for easy access and downlit corner accents",
   "DUALL Guard Filtration",
   "Beverage Holders",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Custom comfort headrest pillows",
   "Diverters: Diverter valves for adjustable therapy",
   "Weathershield Insulated Cover",
   "Synthetic Coated frame",
   "SpaTouch 3 digital touchscreen",
   "M1 Laminated Structure"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Clearplay Plus sound system",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "Unlimited Lighting Package",
   "Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Monaco_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Monaco_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Monaco_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-tradition",
  "name": "Tradition",
  "brand": "Clearwater Spas",
  "series": "Beachcraft Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Tradition is the ideal spa for entertainment in the Beachcraft Series. This spa offers enough room for up to seven people to enjoy a hydrotherapeutic massage while still allowing space for great conversations to flow.",
  "image": "/images/clearwater/Tradition-600-1.png",
  "images": [
   "/images/clearwater/Tradition-600-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "7"
   },
   {
    "label": "Jets",
    "value": "67"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "3"
   },
   {
    "label": "Capacity",
    "value": "7"
   },
   {
    "label": "Size",
    "value": "93″ x 93″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "8′ x 8′ x 3′ (236 x 236 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "3 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "67 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "460 gallons (1741 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "900 lbs. (408 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "4736 lbs. (2148 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Tradition_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Tradition_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Tradition_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/04-CWS_TRADITION_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-pearl-island",
  "name": "Pearl Island",
  "brand": "Clearwater Spas",
  "series": "Beachcraft Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Pearl Island is perfect for luxury and entertainment. With the largest selection of hydromassage therapy jets and three jet pumps, you are guaranteed an unparalleled massage experience.",
  "image": "/images/clearwater/Pearl-Island-1-600-1.png",
  "images": [
   "/images/clearwater/Pearl-Island-1-600-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "6"
   },
   {
    "label": "Jets",
    "value": "64"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "3"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Size",
    "value": "93″ x 93″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "8′ x 8′ x 3′ (236 x 236 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "3 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "64 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "430 gallons (1628 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "900 lbs. (408 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "4736 lbs. (2148 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Pearl-Island_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Pearl-Island_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Pearl-Island_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/05-CWS_PEARLISLAND_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-myrtle-beach",
  "name": "Myrtle Beach",
  "brand": "Clearwater Spas",
  "series": "Beachcraft Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Myrtle Beach offers sophisticated comfort combined with leisure and social connection. It can seat up to seven people at one time, offering you, your family, and your friends an unforgettable spa experience.",
  "image": "/images/clearwater/Myrtle-Beach-600-1.png",
  "images": [
   "/images/clearwater/Myrtle-Beach-600-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "7"
   },
   {
    "label": "Jets",
    "value": "61"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "3"
   },
   {
    "label": "Capacity",
    "value": "7"
   },
   {
    "label": "Size",
    "value": "84″ x 84″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 7′ x 3′ (213 x 213 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "3 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "61 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "350 gallons (1325 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "702 lbs. (318 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3620 lbs. (1642 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Myrtle-Beach_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Myrtle-Beach_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Myrtle-Beach_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-st-andrew",
  "name": "St. Andrew",
  "brand": "Clearwater Spas",
  "series": "Beachcraft Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The St. Andrew is the cozier version of the Pearl Island spa in our Beachcraft Series. This spa accommodates up to six people and provides a luxurious full-body lounger seat for an invigorating massage experience.",
  "image": "/images/clearwater/St.Andrew-2-600-1.png",
  "images": [
   "/images/clearwater/St.Andrew-2-600-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "6"
   },
   {
    "label": "Jets",
    "value": "60"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "3"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Size",
    "value": "84″ x 84″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 7′ x 3′ (213 x 213 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "3 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "60 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "330 gallons (1249 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "702 lbs. (318 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3620 lbs. (1642 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/StAndrew_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/StAndrew_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/StAndrew_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/07-CWS_STANDREW_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-entertainer",
  "name": "Entertainer",
  "brand": "Clearwater Spas",
  "series": "Beachcraft Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Entertainer isn’t just a hot tub — it’s an unparalleled space for connection, relaxation, and fun. Designed for those who love to bring people together, this spacious spa comfortably seats up to nine, with additional standing room for even more guests. Whether you’re hosting a backyard party, unwinding with family, or enjoying a quiet soak under the stars, the Entertainer delivers the perfect blend of social enjoyment and therapeutic comfort. The Entertainer sets the mood for unforgettable moments. With relaxing seating on each side and two deep therapy seats, every seat is the best seat in the house. Experience the quality of Clearwater in a hot tub created for making memories.",
  "image": "/images/clearwater/Entertainer-new-120325-700.png",
  "images": [
   "/images/clearwater/Entertainer-new-120325-700.png",
   "/images/clearwater/Entertainer_Lighting_Standard.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "9"
   },
   {
    "label": "Jets",
    "value": "57"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "3"
   },
   {
    "label": "Capacity",
    "value": "9"
   },
   {
    "label": "Size",
    "value": "137″ x 92″ x 46″"
   },
   {
    "label": "Dimensions",
    "value": "11′ x 8′ x 4′ (348 x 234 x 117 cm)"
   },
   {
    "label": "Dry weight",
    "value": "2,005 lbs / 909 kg"
   },
   {
    "label": "Filled Weight",
    "value": "13,228 lbs / 6,000 kg"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "Lightbar"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Entertainer_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Entertainer_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Entertainer_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-broadmoor",
  "name": "Broadmoor",
  "brand": "Clearwater Spas",
  "series": "Northwest Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Broadmoor is the largest size in our Northwest Series and includes a comfortable lounger seat with capacity for five people. Our Northwest Series is fondly known as our “Performance Series” because it truly makes the most of its space while keeping affordability in mind.",
  "image": "/images/clearwater/broadmoor-600x599-1.png",
  "images": [
   "/images/clearwater/broadmoor-600x599-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "5"
   },
   {
    "label": "Jets",
    "value": "52"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "5"
   },
   {
    "label": "Size",
    "value": "93″ x 93″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "8′ x 8′ x 3′ (236 x 236 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "52 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "460 gallons (1741 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "750 lbs. (340 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "4337 lbs. (1967 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Broadmoor_Lights_Standard-600.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Broadmoor_Lights_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Broadmoor_Lights_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/08-CWS_BROADMOOR_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-concordia",
  "name": "Concordia",
  "brand": "Clearwater Spas",
  "series": "Northwest Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Concordia is one of the largest spas offered in our Northwest Series. Its spacious design includes four shuttle seats and two bench seats for a total capacity of six people. Enjoy relaxing hydrotherapy and an elevated space for social connection with the Concordia.",
  "image": "/images/clearwater/NorthwestSeries_Concordia-600.png",
  "images": [
   "/images/clearwater/NorthwestSeries_Concordia-600.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "6"
   },
   {
    "label": "Jets",
    "value": "53"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Size",
    "value": "93″ x 93″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "8′ x 8′ x 3′ (236 x 236 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Water Capacity",
    "value": "480 gallons (1817 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "750 lbs. (340 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3453 lbs. (1566 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Concordia_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "27",
    "image": "/images/clearwater/Concordia_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "47",
    "image": "/images/clearwater/Concordia_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/09-CWS_CONCORDIA_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-liberty-lake",
  "name": "Liberty Lake",
  "brand": "Clearwater Spas",
  "series": "Northwest Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Liberty Lake is a compact version of the Broadmoor spa in the Northwest Series. With a capacity of five, Liberty Lake includes four cozy seats and an additional lounger, allowing room for engaging conversation or pure relaxation.",
  "image": "/images/clearwater/liberty-lake-600x599-1.png",
  "images": [
   "/images/clearwater/liberty-lake-600x599-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "5"
   },
   {
    "label": "Jets",
    "value": "51"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "5"
   },
   {
    "label": "Size",
    "value": "84″ x 84″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 7′ x 3′ (213 x 213 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "51 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "330 gallons (1249 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "600 lbs. (272 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3438 lbs. (1559 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/LibertyLake_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "26",
    "image": "/images/clearwater/LibertyLake_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "46",
    "image": "/images/clearwater/LibertyLake_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/010-CWS_LIBERTYLAKE_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-fairview",
  "name": "Fairview",
  "brand": "Clearwater Spas",
  "series": "Northwest Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Fairview is the smaller version of the Concordia spa in the Northwest Series and includes seating for six people. Its open-concept design creates the perfect environment for gentle hydrotherapy and effortless entertaining.",
  "image": "/images/clearwater/Fairview-600-1-1.png",
  "images": [
   "/images/clearwater/Fairview-600-1-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "6"
   },
   {
    "label": "Jets",
    "value": "50"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Size",
    "value": "84″ x 84″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 7′ x 3′ (213 x 213 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "50 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "330 gallons (1249 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "600 lbs. (272 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3438 lbs. (1559 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "Auxillary Buttons allows you fingertip control of your custom massage from any seat",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "Bistro Table"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Fairview_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Fairview_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Fairview_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/011-CWS_FAIRVIEW_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-laguna",
  "name": "Laguna",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Discover the perfect blend of relaxation and simplicity with the Fourwinds Series. Featuring a robust 1-pump system, these hot tubs deliver effective hydrotherapy through thoughtfully designed jet configurations and ergonomic seating. The Fourwinds Series combines reliability with comfort, making it an ideal choice for those seeking a tranquil escape. Enhance your wellness journey with the Storm Series – where serenity meets efficiency.",
  "image": "/images/clearwater/FWS-Tropical-Series-Pearl-I-Laguna.png",
  "images": [
   "/images/clearwater/FWS-Tropical-Series-Pearl-I-Laguna.png",
   "/images/clearwater/FourwindsSeries_HeroImage-1200.jpg"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "4"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Jets",
    "value": "22"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Size",
    "value": "76″ x 76″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "6′ x 6′ x 3′ (193 x 193 x 84 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "1 High Volume hydrotherapy pump"
   },
   {
    "label": "Hydrotherapy",
    "value": "22 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "450 gallons (1703 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "649 lbs. (294 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "4399 lbs. (1995 kg)"
   },
   {
    "label": "Specification",
    "value": "Made in Washington and Tennesee"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Multi-function pump (Circ Pump)",
   "Beverage Holders",
   "Energy Efficiency: E-Smart & CEC",
   "Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Custom comfort headrest pillows",
   "TP 600 Topside control Panel",
   "Weathershield Insulated Cover",
   "Synthetic Coated frame",
   "M1 Laminated Structure"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "SpaTouch 3 digital touchscreen",
   "Clearplay Plus sound system",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "Unlimited Lighting Package",
   "Duratech Plus Cabinetry",
   "Lightbar"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Standard",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Standard",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Standard",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [],
  "equipmentLayout": "/docs/clearwater/020-CWS_LAGUNA_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-nashville",
  "name": "Nashville",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Discover the perfect blend of relaxation and simplicity with the Fourwinds Series. Featuring a robust 1-pump system, these hot tubs deliver effective hydrotherapy through thoughtfully designed jet configurations and ergonomic seating. The Fourwinds Series combines reliability with comfort, making it an ideal choice for those seeking a tranquil escape. Enhance your wellness journey with the Storm Series – where serenity meets efficiency.",
  "image": "/images/clearwater/FourwindsSeries_HeroImage-1200.jpg",
  "images": [
   "/images/clearwater/FourwindsSeries_HeroImage-1200.jpg",
   "/images/clearwater/FWS-Tropical-Series-Pearl-I-Laguna.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "3"
   },
   {
    "label": "Capacity",
    "value": "3"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Jets",
    "value": "22"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Size",
    "value": "83″ x 66″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 6′ x 3′ ( 211 x 168 x 84 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "1 High Volume hydrotherapy pump"
   },
   {
    "label": "Hydrotherapy",
    "value": "22 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "450 gallons (1703 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "649 lbs. (294 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "4399 lbs. (1995 kg)"
   },
   {
    "label": "Specification",
    "value": "Made in Washington and Tennesee"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "SpaTouch 3 digital touchscreen"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Standard",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Standard",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Standard",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Tuffx Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [],
  "equipmentLayout": "/docs/clearwater/019-CWS_NASHVILLE_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-kauai",
  "name": "Kauai",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Kauai is a seven-foot spa in our Fourwinds Series designed to seat up to seven people comfortably with its open-concept design. Built to exceed industry standards, Kauai offers a balanced number of jets to provide outstanding hydrotherapy in every seat. It’s the perfect blend of tradition and comfort.",
  "image": "/images/clearwater/Kauai-new.png",
  "images": [
   "/images/clearwater/Kauai-new.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "7"
   },
   {
    "label": "Jets",
    "value": "45"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "7"
   },
   {
    "label": "Size",
    "value": "83″ x 83″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 7′ x 3′ (211 x 211 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "45 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "450 gallons (1703 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "750 lbs. (340 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "4505 lbs. (2043 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "upgrades": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Kauai_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Kauai_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Kauai_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/014-CWS_KAUAI_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-titanium",
  "name": "Titanium",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Titanium is a seven-foot spa in our Fourwinds Series, celebrated for its classic design and outstanding performance. Crafted with comfort in mind, this spa features a contoured lounger that lets you lay back and relax in style, providing the perfect spot for refined relaxation.",
  "image": "/images/clearwater/Four-Winds-Line-Titanium-Mockup.png",
  "images": [
   "/images/clearwater/Four-Winds-Line-Titanium-Mockup.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "5"
   },
   {
    "label": "Jets",
    "value": "40"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "5"
   },
   {
    "label": "Size",
    "value": "84″ x 84″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 7′ x 3′(213 x 213 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "40 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "340 gallons (1287 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "600 lbs. (272 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3438 lbs. (1559 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "SpaTouch 3 digital touchscreen"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Titanium_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Titanium_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Titanium_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-caribbean",
  "name": "Caribbean",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Caribbean is a spacious family spa designed for maximum relaxation and comfort. It features four upright seats and a built-in lounger for those who love to unwind fully. With 45 strategically placed massage jets, it delivers a soothing hydrotherapy experience that will remind you exactly why a hot tub belongs on your wish list.",
  "image": "/images/clearwater/FourwindsSeries-Caribbean.png",
  "images": [
   "/images/clearwater/FourwindsSeries-Caribbean.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "5"
   },
   {
    "label": "Jets",
    "value": "45"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "5"
   },
   {
    "label": "Size",
    "value": "93″ x 93″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "8′ x 8′ x 3′ (236 x 236 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "45 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "450 gallons (1703 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "750 lbs. (340 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "4505 lbs. (2043 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "SpaTouch 3 digital touchscreen"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Caribbean_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Caribbean_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Caribbean_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-key-largo",
  "name": "Key Largo",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Key Largo is a six-foot, six-seat spa for the Fourwinds Series. With a balanced arrangement of 39 jets, Key Largo delivers premium relaxation and a soothing hydrotherapy massage to every seat.",
  "image": "/images/clearwater/Key-Largo_Filter.png",
  "images": [
   "/images/clearwater/Key-Largo_Filter.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "6"
   },
   {
    "label": "Jets",
    "value": "39"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Size",
    "value": "76″ x 76″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "6′ x 6′ x 3′ (193 x 193 x 84 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Water Capacity",
    "value": "300 gallons (1136 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "422 lbs. (191 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "2922 lbs. (1325 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "SpaTouch 3 digital touchscreen"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Key-Largo_Lighting_Standard.png"
   },
   {
    "name": "",
    "lights": null,
    "image": "/images/clearwater/Key-Largo_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "35",
    "image": "/images/clearwater/Key-Largo_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/016-CWS_KEYLARGO_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-daytona-beach",
  "name": "Daytona Beach",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Daytona Beach is a six-foot, four-person spa in the Fourwinds Series and includes a restorative lounger seat. Wherever you sit, enjoy tranquil hydrotherapy with Daytona Beach.",
  "image": "/images/clearwater/Daytona-Beach_NewTopside.png",
  "images": [
   "/images/clearwater/Daytona-Beach_NewTopside.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "4"
   },
   {
    "label": "Jets",
    "value": "36"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "4"
   },
   {
    "label": "Size",
    "value": "76″ x 76″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "6′ x 6′ x 3′ (193 x 193 x 84 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Water Capacity",
    "value": "260 gallons (984 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "422 lbs. (191 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "2593 lbs. (1176 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "SpaTouch 3 digital touchscreen"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Daytona-Beach_Lighting_Standard.png"
   },
   {
    "name": "",
    "lights": null,
    "image": "/images/clearwater/Daytona-Beach_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "35",
    "image": "/images/clearwater/Daytona-Beach_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/017-CWS_DAYTONABEACH_EquipmentLayout_Updated-compressed.pdf"
 },
 {
  "id": "cw-trilogy",
  "name": "Trilogy",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Finding a smaller spa that offers as much interior space as the Trilogy is no easy task. With its thoughtfully designed intimate layout, the Trilogy provides comfortable seating, making it the perfect choice for spaces where every inch counts without compromising on comfort.",
  "image": "/images/clearwater/Trilogy-new-120325-2-700.png",
  "images": [
   "/images/clearwater/Trilogy-new-120325-2-700.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "3"
   },
   {
    "label": "Jets",
    "value": "33"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "3"
   },
   {
    "label": "Size",
    "value": "83″ x 66″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 6′ x 3′ (211 x 168 x 84 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "33 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "240 gallons (908 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "600 lbs. (272 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3438 lbs. (1559 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "SpaTouch 3 digital touchscreen"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Trilogy_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "15",
    "image": "/images/clearwater/Trilogy_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "35",
    "image": "/images/clearwater/Trilogy_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-grand-bahama",
  "name": "Grand Bahama",
  "brand": "Clearwater Spas",
  "series": "Fourwinds Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Grand Bahama is the largest spa in our Fourwinds Series, known for its timeless design and exceptional performance. The Fourwinds Series represents our commitment to traditional craftsmanship, built to exceed industry standards. With a thoughtfully balanced number of jets, it ensures superior hydrotherapy in every seat, offering a truly therapeutic experience for all.",
  "image": "/images/clearwater/Daytona-Beach_NewTopside.png",
  "images": [
   "/images/clearwater/Daytona-Beach_NewTopside.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "7"
   },
   {
    "label": "Jets",
    "value": "45"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "2"
   },
   {
    "label": "Capacity",
    "value": "7"
   },
   {
    "label": "Size",
    "value": "93″ x 93″ x 38″"
   },
   {
    "label": "Dimensions",
    "value": "8′ x 8′ x 3′ (236 x 236 x 97 cm)"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   },
   {
    "label": "Pumps",
    "value": "2 High Volume hydrotherapy pumps"
   },
   {
    "label": "Hydrotherapy",
    "value": "45 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "450 gallons (1703 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "750 lbs. (340 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "4505 lbs. (2043 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "8 Foot Spa Duratech Plus Cabinetry",
   "Lightbar",
   "SpaTouch 3 digital touchscreen"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Grand-Bahama_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "25",
    "image": "/images/clearwater/Grand-Bahama_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": "45",
    "image": "/images/clearwater/Grand-Bahama_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-starlight-7n",
  "name": "Starlight 7N",
  "brand": "Clearwater Spas",
  "series": "Starlight Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Possibly the largest plug-and-play spa on the market today, this Starlight model delivers impressive performance with an all open-concept seating design built for comfort and flexibility. With 20 therapy jets and simple 115V plug-and-play convenience, it offers relaxing hydrotherapy without the hassle or cost of complex installation. The spacious open layout maximizes interior room, making it perfect for families, entertaining, or anyone who wants more space to stretch out and unwind. Big comfort. Easy setup. Pure Starlight relaxation.",
  "image": "/images/clearwater/Starlight7N_BlackJets_Frost.png",
  "images": [
   "/images/clearwater/Starlight7N_BlackJets_Frost.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "6"
   },
   {
    "label": "Jets",
    "value": "20"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Size",
    "value": "84″ x 84″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 7′ x 3′ (213 x 213 x 97 cm)"
   },
   {
    "label": "Electrical",
    "value": "110 volt – includes power cord 15-amp GFCI"
   },
   {
    "label": "Hydrotherapy",
    "value": "20 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "340 gallons (1287 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "750 lbs. (340 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3620 lbs. (1642 kg)"
   }
  ],
  "keyFeatures": [
   {
    "label": "Jets",
    "value": "20 therapy jets for balanced hydrotherapy"
   },
   {
    "label": "Seating",
    "value": "Fully open-concept layout for flexible comfort"
   },
   {
    "label": "Size",
    "value": "One of the largest plug-and-play spas available"
   },
   {
    "label": "Electrical",
    "value": "115V plug-and-play (dedicated 15A outlet required)"
   },
   {
    "label": "Installation",
    "value": "Simple setup with no costly electrical upgrades"
   },
   {
    "label": "Perfect For",
    "value": "Families, cottages, Airbnbs, and easy backyard relaxation"
   }
  ],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Water Feature",
   "Synthetic Coated frame",
   "Multi-function pump (Circ Pump)"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Stealth Mode Pump",
   "M1 Laminated Structure"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "1",
    "image": "/images/clearwater/Starlight7N_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "4",
    "image": "/images/clearwater/Starlight7N_Lighting_FirstChoice.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/CWS_EquipmentLayout_Starlight7N-11-08-2026-15_40_39_058.pdf"
 },
 {
  "id": "cw-starlight-7l",
  "name": "Starlight 7L",
  "brand": "Clearwater Spas",
  "series": "Starlight Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Plug In. Power On. Relax. The Starlight 7L delivers impressive performance in a convenient plug-and-play package. Featuring a comfortable lounger seat design and 20 therapy jets, this spa offers full-body relaxation without the complexity of traditional installations. With 115V plug-and-play convenience, setup is simple — just connect to a dedicated 15A outlet and you’re ready to soak. No expensive electrical upgrades. No complicated installation. Just effortless relaxation. Its family-size open seating layout makes it ideal for everyday use — and perfect for an Airbnb, second home, or cottage retreat. Easy to install. Easy to enjoy. Jets : 20 therapy jets for balanced hydrotherapy Lounger : Reclined seat for head-to-toe relaxation Electrical : 115V plug-and-play (dedicated 15A outlet required) Installation : No costly electrical work needed Seating : Open family-size layout Perfect For : Airbnb properties, vacation homes, cottages, and first-time spa buyers",
  "image": "/images/clearwater/Starlight7L_BlackJets_Frost.png",
  "images": [
   "/images/clearwater/Starlight7L_BlackJets_Frost.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "5"
   },
   {
    "label": "Jets",
    "value": "20"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Capacity",
    "value": "5"
   },
   {
    "label": "Size",
    "value": "84″ x 84″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 7′ x 3′ (213 x 213 x 97 cm)"
   },
   {
    "label": "Electrical",
    "value": "110 volt – includes power cord 15-amp GFCI"
   },
   {
    "label": "Hydrotherapy",
    "value": "20 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "310 gallons (1173 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "750 lbs. (340 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "3455 lbs. (1567 kg)"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Water Feature",
   "Synthetic Coated frame",
   "Multi-function pump (Circ Pump)"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Stealth Mode Pump",
   "M1 Laminated Structure"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "1",
    "image": "/images/clearwater/Starlight7L_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "4",
    "image": "/images/clearwater/Starlight7L_Lighting_FirstChoice.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/CWS_EquipmentLayout_Starlight7L-11-08-2026-15_40_39_058.pdf"
 },
 {
  "id": "cw-starlight-6n",
  "name": "Starlight 6N",
  "brand": "Clearwater Spas",
  "series": "Starlight Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Starlight 6N delivers dependable hydrotherapy with 20 therapy jets in an easy plug-and-play 115V format. Designed with an open seating layout and minimal interior obstacles, this spa reduces stumble hazards and makes movement inside the tub easy and comfortable. Its low-profile design allows you to simply sit on the edge and pivot in — making entry and exit smooth and natural. Comfortable. Practical. Relaxation made easy.",
  "image": "/images/clearwater/Starlight6N_BlackJets_Frost.png",
  "images": [
   "/images/clearwater/Starlight6N_BlackJets_Frost.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "6"
   },
   {
    "label": "Jets",
    "value": "20"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Capacity",
    "value": "6"
   },
   {
    "label": "Size",
    "value": "76″ x 76″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "6′ x 6′ x 3′ (193 x 193 x 84 cm)"
   },
   {
    "label": "Electrical",
    "value": "110 volt – includes power cord 15-amp GFCI"
   },
   {
    "label": "Hydrotherapy",
    "value": "20 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "300 gallons (1136 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "422 lbs. (191 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "2922 lbs. (1325 kg)"
   }
  ],
  "keyFeatures": [
   {
    "label": "Jets",
    "value": "20 therapy jets for balanced hydrotherapy"
   },
   {
    "label": "Electrical",
    "value": "115V plug-and-play operation (dedicated outlet required)"
   },
   {
    "label": "Seating",
    "value": "Open-concept layout with fewer barriers"
   },
   {
    "label": "Safety",
    "value": "Designed with minimal stumble hazards"
   },
   {
    "label": "Entry",
    "value": "Low-profile height for easy sit-and-pivot access"
   },
   {
    "label": "Perfect For",
    "value": "Families, cottages, rentals, and homeowners who value easy entry"
   }
  ],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Water Feature",
   "Synthetic Coated frame",
   "Multi-function pump (Circ Pump)"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Stealth Mode Pump",
   "M1 Laminated Structure"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "1",
    "image": "/images/clearwater/Starlight6N_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "4",
    "image": "/images/clearwater/Starlight6N_Lighting_FirstChoice.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/CWS_EquipmentLayout_Starlight6N-11-08-2026-15_40_39_058.pdf"
 },
 {
  "id": "cw-starlight-6l",
  "name": "Starlight 6L",
  "brand": "Clearwater Spas",
  "series": "Starlight Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Starlight 6L delivers full-body relaxation in a convenient plug-and-play design. With a full-length lounger and 20 therapy jets, this spa is made for stretching out, sinking in, and letting the stress disappear. Running on 115V plug-and-play power, installation is simple — no expensive electrical work, just a dedicated outlet and you’re ready to soak. It’s also one of the most popular Airbnb models we build, because it truly checks all the boxes: comfort, performance, simplicity, and durability. And for added peace of mind, the Starlight 6L features a tough-as-nails Frost ABS shell, designed for extra impact resistance — perfect for high-use environments like rentals, cabins, and vacation homes. Relaxation made easy. Built to last.",
  "image": "/images/clearwater/Starlight6L_BlackJets_Frost.png",
  "images": [
   "/images/clearwater/Starlight6L_BlackJets_Frost.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "5"
   },
   {
    "label": "Jets",
    "value": "20"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Capacity",
    "value": "5"
   },
   {
    "label": "Size",
    "value": "76″ x 76″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "6′ x 6′ x 3′ (193 x 193 x 84 cm)"
   },
   {
    "label": "Electrical",
    "value": "110 volt – includes power cord 15-amp GFCI"
   },
   {
    "label": "Hydrotherapy",
    "value": "20 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "260 gallons (984 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "411 lbs. (186 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "2245 lbs. (1018 kg)"
   }
  ],
  "keyFeatures": [
   {
    "label": "Jets",
    "value": "20 therapy jets for balanced hydrotherapy"
   },
   {
    "label": "Lounger",
    "value": "Full-length reclined seat for head-to-toe comfort"
   },
   {
    "label": "Electrical",
    "value": "115V plug-and-play operation (dedicated outlet required)"
   },
   {
    "label": "Popularity",
    "value": "One of our top choices for Airbnb and vacation properties"
   },
   {
    "label": "Shell",
    "value": "Frost ABS shell for extra durability and impact resistance"
   },
   {
    "label": "Perfect For",
    "value": "Short-term rentals, cottages, second homes, and easy backyard installs"
   }
  ],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Water Feature",
   "Synthetic Coated frame",
   "Multi-function pump (Circ Pump)"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Stealth Mode Pump",
   "M1 Laminated Structure"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "1",
    "image": "/images/clearwater/Starlight6L_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "4",
    "image": "/images/clearwater/Starlight6L_Lighting_FirstChoice.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/CWS_EquipmentLayout_Starlight6L-11-08-2026-15_40_39_058.pdf"
 },
 {
  "id": "cw-starlight-6r",
  "name": "Starlight 6R",
  "brand": "Clearwater Spas",
  "series": "Starlight Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "The Starlight 6R is our most compact plug-and-play model, designed specifically for patios, small decks, and tighter outdoor spaces. With easy 115V convenience and a space-saving footprint, it’s a great option when you want the benefits of a hot tub without needing a large installation area. Because of its cozy, efficient layout, the Starlight 6R is best suited for those looking for an intimate soaking experience and may feel most comfortable for average-sized adults. Small space. Simple setup. Relaxation made easy.",
  "image": "/images/clearwater/Starlight6R_BlackJets_Frost-1.png",
  "images": [
   "/images/clearwater/Starlight6R_BlackJets_Frost-1.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "3"
   },
   {
    "label": "Jets",
    "value": "20"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Capacity",
    "value": "3"
   },
   {
    "label": "Size",
    "value": "76″ x 53″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "6′ x 4′ x 3′ (193 x 135 x 84 cm)"
   },
   {
    "label": "Electrical",
    "value": "110 volt – includes power cord 15-amp GFCI"
   },
   {
    "label": "Hydrotherapy",
    "value": "20 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "180 gallons (681 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "360 lbs. (163 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "1861 lbs. (844 kg)"
   }
  ],
  "keyFeatures": [
   {
    "label": "Model Type",
    "value": "Most compact Starlight plug-and-play spa"
   },
   {
    "label": "Footprint",
    "value": "Ideal for patios, small decks, and limited spaces"
   },
   {
    "label": "Electrical",
    "value": "115V plug-and-play operation"
   },
   {
    "label": "Experience",
    "value": "Cozy seating layout designed for efficient relaxation"
   },
   {
    "label": "Perfect For",
    "value": "Smaller outdoor areas, cottages, and first-time spa owners"
   }
  ],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Water Feature",
   "Synthetic Coated frame",
   "Multi-function pump (Circ Pump)"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "Multi-function pump (Circ Pump)",
   "Stealth Mode Pump",
   "M1 Laminated Structure"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "1",
    "image": "/images/clearwater/Starlight6R_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "4",
    "image": "/images/clearwater/Starlight6R_Lighting_FirstChoice.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/CWS_EquipmentLayout_Starlight6R-11-08-2026-15_40_39_058.pdf"
 },
 {
  "id": "cw-starlight-5n",
  "name": "Starlight 5N",
  "brand": "Clearwater Spas",
  "series": "Starlight Series",
  "category": "Hot Tub",
  "tagline": "",
  "description": "Affordable Comfort, Plug-and-Play Easy The Starlight 5N is our most affordable plug-and-play spa, delivering essential relaxation with 20 therapy jets in a simple, convenient 115V design. Its bright, open seating layout is designed to delight — offering comfortable space, easy movement, and the perfect entry point into everyday hydrotherapy. New for 2026, the Starlight 5N is already generating excitement and is expected to be a standout favorite for Clearwater dealers and customers alike. Big value. Easy setup. A new star in the lineup.",
  "image": "/images/clearwater/Starlight5N_BlackJets_Frost.png",
  "images": [
   "/images/clearwater/Starlight5N_BlackJets_Frost.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "5"
   },
   {
    "label": "Jets",
    "value": "20"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Capacity",
    "value": "5"
   },
   {
    "label": "Size",
    "value": "78″ x 66″ x 33″"
   },
   {
    "label": "Dimensions",
    "value": "7 ′ x 6′ x 3′ (198 x 168 x 84 cm)"
   },
   {
    "label": "Electrical",
    "value": "110 volt – includes power cord 15-amp GFCI"
   },
   {
    "label": "Hydrotherapy",
    "value": "20 hydrotherapy jets, multiple zone air controls"
   },
   {
    "label": "Water Capacity",
    "value": "300 gallons (1136 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "360 lbs. (163 kg)"
   },
   {
    "label": "Filled Weight",
    "value": "1861 lbs. (844 kg)"
   }
  ],
  "keyFeatures": [
   {
    "label": "Jets",
    "value": "20 therapy jets for essential hydrotherapy"
   },
   {
    "label": "Value",
    "value": "Our most affordable plug-and-play model"
   },
   {
    "label": "Seating",
    "value": "Open-concept design for comfort and flexibility"
   },
   {
    "label": "Electrical",
    "value": "115V plug-and-play convenience"
   },
   {
    "label": "New for 2026",
    "value": "A fresh addition with strong demand expected"
   },
   {
    "label": "Perfect For",
    "value": "First-time spa owners, cottages, rentals, and budget-smart buyers"
   }
  ],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "TP 600 Topside control Panel",
   "Water Feature",
   "Synthetic Coated frame",
   "Multi-function pump (Circ Pump)"
  ],
  "upgrades": [
   "Cold Weather Package (Double Insulation)",
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: UVOZ clean water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "7 Foot Spa Duratech Plus Cabinetry",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Stealth Mode Pump",
   "M1 Laminated Structure"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Tuscan Sun",
    "image": "/images/clearwater/colors/tuscan-sun.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Kalahari",
    "image": "/images/clearwater/colors/kalahari.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Dakota",
    "image": "/images/clearwater/colors/dakota.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Storm Cloud",
    "image": "/images/clearwater/colors/storm-clouds.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Midnight Canyon",
    "image": "/images/clearwater/colors/midnight-canyon.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Smoky Mountain",
    "image": "/images/clearwater/colors/smoky-mountain.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": "5",
    "image": "/images/clearwater/Starlight5N_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": "0",
    "image": "/images/clearwater/Starlight5N_Lighting_FirstChoice.png"
   }
  ],
  "equipmentLayout": "/docs/clearwater/025-CWS_STAR6_EquipmentLayout.pdf"
 },
 {
  "id": "cw-xl16000",
  "name": "XL16000",
  "brand": "Clearwater Spas",
  "series": "Swim Series",
  "category": "Swim Spa",
  "tagline": "",
  "description": "The XL16000 combines fitness and relaxation in one stunning swim spa. Featuring three powerful River Jets for resistance swimming and 35 strategically placed hydrotherapy jets, this model offers an unparalleled spa experience. Perfect for fitness enthusiasts or families looking for a space to both exercise and unwind, the XL16000 seats up to four people, making it a perfect addition to any home. Dive into luxury and health with the XL16000!",
  "image": "/images/clearwater/16000-swim-spas-clearwater-spas-500-2.png",
  "images": [
   "/images/clearwater/16000-swim-spas-clearwater-spas-500-2.png",
   "/images/clearwater/16000_Lighting_Standard.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "4"
   },
   {
    "label": "Two-Tone Jets",
    "value": "32"
   },
   {
    "label": "Lounger",
    "value": "1"
   },
   {
    "label": "River Jets",
    "value": "3"
   },
   {
    "label": "Capacity",
    "value": "9"
   },
   {
    "label": "Size",
    "value": "191″ x 90″ x 55″"
   },
   {
    "label": "Pumps",
    "value": "3"
   },
   {
    "label": "Dimensions",
    "value": "16′ x 8′ x 5′ (485 x 229 x 140 cm)"
   },
   {
    "label": "Jets",
    "value": "32 Two-Tone Jets + 3 River Jets"
   },
   {
    "label": "Water Capacity",
    "value": "1921 gallons (7273 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "2505 lbs/1136 kgs"
   },
   {
    "label": "Filled Weight",
    "value": "18539 lbs/8409 kgs"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "Swim Spa Water Treatment: UVOZ clean water purification system",
   "Swim Spa Lightbar",
   "Full Exercise Package",
   "Swim Spa Cold Weather Package (Double Insulation)"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": null,
    "image": "/images/clearwater/16000_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": null,
    "image": "/images/clearwater/16000_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": null,
    "image": "/images/clearwater/16000_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-xl14000",
  "name": "XL14000",
  "brand": "Clearwater Spas",
  "series": "Swim Series",
  "category": "Swim Spa",
  "tagline": "",
  "description": "Smaller in size but big on performance, the XL14000 offers the same powerful features as its larger counterparts. Designed with three River Jets for an exceptional swim experience and 32 hydrotherapy jets for maximum relaxation, this swim spa is ideal for families or individuals looking to bring the benefits of a swim spa to a smaller backyard. With seating for four, it’s the perfect blend of fitness and hydrotherapy.",
  "image": "/images/clearwater/14000-swim-spas-clearwater-spas-500.png",
  "images": [
   "/images/clearwater/14000-swim-spas-clearwater-spas-500.png",
   "/images/clearwater/XL14000-new-120325-700.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "4"
   },
   {
    "label": "Two-Tone Jets",
    "value": "29"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "River Jets",
    "value": "3"
   },
   {
    "label": "Capacity",
    "value": "9"
   },
   {
    "label": "Size",
    "value": "168″ x 90″ x 55″"
   },
   {
    "label": "Pumps",
    "value": "3"
   },
   {
    "label": "Dimensions",
    "value": "14′ x 8′ x 5′ (427 x 229 x 140 cm)"
   },
   {
    "label": "Jets",
    "value": "29 Two-Tone Jets + 3 River Jets"
   },
   {
    "label": "Water Capacity",
    "value": "1966 gallons (7445 litres)"
   },
   {
    "label": "Weight Dry",
    "value": "2126 lbs/964 kgs"
   },
   {
    "label": "Filled Weight",
    "value": "18539 lbs/8409 kgs"
   },
   {
    "label": "Electrical Requirements",
    "value": "240 volt / 50-amp GFCI"
   }
  ],
  "keyFeatures": [],
  "features": [
   "Lighted footwell for easy access and downlit corner accents",
   "Energy Efficiency: E-Smart & CEC Certified",
   "Insulation: Reflective Thermal Barrier (RTB) insulation",
   "Everlast Floor",
   "TUFFX cabinetry",
   "Weathershield Insulated Cover",
   "Diverters: Diverter valves for adjustable therapy",
   "Custom comfort headrest pillows",
   "M1 Laminated Structure",
   "Beverage Holders",
   "Water Feature",
   "SpaTouch 3 digital touchscreen"
  ],
  "upgrades": [
   "Spa Logic WIFI remote Control System",
   "Water Treatment: Ozone water purification system",
   "Water Treatment: Clear (state-of-the-art water management system)",
   "FirstChoice Lighting Package",
   "DUALL Guard Filtration",
   "Multi-function pump (Circ Pump)",
   "Clearplay Plus sound system",
   "Unlimited Lighting Package",
   "Lightbar",
   "Swim Spa Water Treatment: UVOZ clean water purification system",
   "Swim Spa Lightbar",
   "Full Exercise Package",
   "Swim Spa Cold Weather Package (Double Insulation)"
  ],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   }
  ],
  "lighting": [
   {
    "name": "Standard",
    "lights": null,
    "image": "/images/clearwater/14000_Lighting_Standard.png"
   },
   {
    "name": "Firstchoice",
    "lights": null,
    "image": "/images/clearwater/14000_Lighting_FirstChoice.png"
   },
   {
    "name": "Unlimited",
    "lights": null,
    "image": "/images/clearwater/14000_Lighting_Unlimited.png"
   }
  ],
  "equipmentLayout": null
 },
 {
  "id": "cw-rejuvenate",
  "name": "Rejuvenate",
  "brand": "Clearwater Spas",
  "series": "Cold Series",
  "category": "Cold Plunge",
  "tagline": "Rejuvenate – Refresh. Recover. Repeat.",
  "description": "The Rejuvenate Cold Plunge delivers the powerful benefits of cold water therapy in a simple, accessible format. Designed to support muscle recovery, circulation, and mental clarity, this plunge makes it easy to incorporate cold immersion into your daily routine. Powered by an energy-efficient heat pump, the Rejuvenate gives you the best of both worlds: Train hard? Keep it cold for recovery. Feeling cozy? Warm it up for those chilly days when a hot soak sounds better than an ice bath. With 115V plug-and-play convenience, setup is quick and straightforward — just connect to a dedicated outlet and start enjoying wellness your way. Cold when you want it. Warm when you need it.",
  "image": "/images/clearwater/Rejuvenate_NEW_June2026.png",
  "images": [
   "/images/clearwater/Rejuvenate_NEW_June2026.png"
  ],
  "specs": [
   {
    "label": "Seats",
    "value": "1"
   },
   {
    "label": "Jets",
    "value": "1"
   },
   {
    "label": "Lounger",
    "value": "0"
   },
   {
    "label": "Pumps",
    "value": "1"
   },
   {
    "label": "Capacity",
    "value": "1"
   },
   {
    "label": "Size",
    "value": "83″ x 37″ x 31″"
   },
   {
    "label": "Dimensions",
    "value": "7′ x 3′ x 3′ (211 x 94 x 79 cm)"
   },
   {
    "label": "Cover",
    "value": "Black"
   }
  ],
  "keyFeatures": [
   {
    "label": "Therapy Type",
    "value": "Cold water immersion with optional heating flexibility"
   },
   {
    "label": "Heat Pump",
    "value": "Energy-efficient system for temperature control"
   },
   {
    "label": "Dual-Use",
    "value": "Cold plunge for training, warm soak for comfort days"
   },
   {
    "label": "Electrical",
    "value": "115V plug-and-play operation"
   },
   {
    "label": "Installation",
    "value": "No complex electrical upgrades required"
   },
   {
    "label": "Perfect For",
    "value": "Athletes, wellness enthusiasts, and year-round recovery"
   }
  ],
  "features": [
   "Clim8zone II (40°F – 104°F)",
   "110V GFCI Cord Included",
   "Spa Light"
  ],
  "upgrades": [],
  "colors": [
   {
    "group": "Shell Colors",
    "type": "Standard",
    "name": "Frost",
    "image": "/images/clearwater/colors/sterling-sliver.jpg"
   },
   {
    "group": "Shell Colors",
    "type": "Custom",
    "name": "Sterling Silver",
    "image": "/images/clearwater/colors/shell-sterling-silver.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "American Mahogany",
    "image": "/images/clearwater/colors/american-mahogany-espresso.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Gun Metal Gray",
    "image": "/images/clearwater/colors/gun-metal-grey.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Tuffx",
    "name": "Raven",
    "image": "/images/clearwater/colors/raven-black.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Gray",
    "image": "/images/clearwater/colors/cabinet-standard-gray.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Brown",
    "image": "/images/clearwater/colors/cabinet-standard-brown.jpg"
   },
   {
    "group": "Cabinets",
    "type": "Duratech Plus",
    "name": "Ivory",
    "image": "/images/clearwater/colors/cabinet-standard-ivory.jpg"
   }
  ],
  "lighting": [],
  "equipmentLayout": null
 }
];

export const CLEARWATER_HOT_TUBS = CLEARWATER_SPAS.filter(p => p.category === 'Hot Tub');
export const CLEARWATER_SWIM_SPAS = CLEARWATER_SPAS.filter(p => p.category === 'Swim Spa');
export const CLEARWATER_COLD_TUBS = CLEARWATER_SPAS.filter(p => p.category === 'Cold Plunge');
